/* 
 *  This file district.model.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2022  
 *  (C) 2015-2022. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *  
 */

import { PaginationModel, LinksModel } from '../../../../../global/models/common.models';
import { FormControl } from '@angular/forms';

export enum districtUrls {
    districtList = '/api/core/District',
    districtSearch = '/api/core/District/Search',
    districtInsert = '/api/core/District',
    districtUpdate = '/api/core/District',
    districtDelete = '/api/core/District',
    employeeCount = '/api/core/District/EmployeeCount',
    totalCount = '/api/core/District/TotalCount'
}

export interface DistrictGridRequestModel {
    countryCode: string;
    businessRegionCode: string;
    districtCode: string;
    status: string;
    globalRegionCode?: string;
    pagination: PaginationModel;
}

export const districtGridRequestData: DistrictGridRequestModel = {
    countryCode: '',
    businessRegionCode: '',
    districtCode: '',
    status: '1',
    globalRegionCode: '',
    pagination: {
        pageNumber: 1,
        pageSize: 10
    }
};

export interface DistrictModel {
    districtCode?: string;
    districtName?: string;
    activeStatus?: string;
    stateCode?: string;
}

export interface DistrictGridResponseModel {
    countryCode?: string;
    countryName?: string;
    internationalCode?: string;
    nationality?: string;
    activeStatus?: string;
    globalRegionId?: number;
    globalRegionCode?: string;
    globalRegionName?: string;
    districtCode?: string;
    districtName?: string;
    stateCode?: string;
    stateName?: string;
    businessRegionCode?: string;
    businessRegionName?: string;
    links?: LinksModel[];
    employeeCountLink?: string;
    employeeCount?: string;
}

export interface DistrictSearchResponseModel {
    code?: string;
    name?: string;
}

export const districtFormEmptyData: DistrictModel = {
    districtCode: '',
    districtName: '',
    activeStatus: '1',
    stateCode: ''
};

export interface DistrictFilterModel {
    active: boolean;
    inactive: boolean;
    selected_global_region: Array<{ key: string; value: string }>;
    selected_country: Array<{ key: string; value: string }>;
    selected_business_region: Array<{ key: string; value: string }>;
    selected_district: Array<{ key: string; value: string }>;
}

export const districtFilterSkeleton: DistrictFilterModel = {
    active: true,
    inactive: false,
    selected_global_region: [] as Array<{ key: string; value: string }>,
    selected_country: [] as Array<{ key: string; value: string }>,
    selected_business_region: [] as Array<{ key: string; value: string }>,
    selected_district: [] as Array<{ key: string; value: string }>
};

// Form interface for type safety
export interface DistrictFormInterface {
    districtCode: FormControl<string | null>;
    districtName: FormControl<string | null>;
    globalRegionCode: FormControl<string | null>;
    countryCode: FormControl<string | null>;
    businessRegionCode: FormControl<string | null>;
    stateCode: FormControl<string | null>;
    activeStatus: FormControl<string | null>;
}

// Interface for dropdown options
export interface DropdownOption {
    key: string;
    value: string;
    globalRegionId?: string | number;
}

// Interface for button config
export interface ButtonConfig {
    text: string;
    index: number;
}

// Interface for confirm dialog
export interface ConfirmDialog {
    show: boolean;
}

// Interface for access rights
export interface AccessRights {
    view: boolean;
    add: boolean;
    update: boolean;
    delete: boolean;
    import: boolean;
} 

// Interface for menu item
export interface MenuItem {
  label: string;
  command: () => void;
} 